import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import classnames from "classnames";
import style from "./IOExecution.module.scss";
import InlineDetail from "../../IO/InlineItem";
import { IOMode, IOType, TransactionStatus } from "../../IO/types";
import { SimpleSuggest } from "../IO/Fields";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";

const Securities = ({ io, items, errors, onChange, services }) => {
  return (
    <div className={style.securities}>
      <Table>
        <thead>
          <tr>
            <th>Quantity</th>
            <th>Security</th>
            {io.IOType != IOType.Transfer && <th>Custodian</th>}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={`sec-${item.Id}`}>
              <td>
                <FormattedNumber value={item.Quantity} dataTypeDecimalName="quantity" />
              </td>
              <td>{item.IsCurrency ? item.CurrencyISO : item.AssetTicker}</td>
              {io.IOType != IOType.Transfer && (
                <td>
                  <SimpleSuggest
                    label={"Custodian"}
                    noLabel={true}
                    disabled={io.Status == TransactionStatus.FILLED}
                    service={services.fetchSearchCustodian}
                    error={errors[item.Id] ? errors[item.Id].CustodianId : undefined}
                    value={item.CustodianName}
                    onChange={({ id, name }) => {
                      onChange(item.Id, { CustodianId: id, CustodianName: name });
                    }}
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export function validateSecurities(items) {
  const errors = {};

  items.forEach((item) => {
    errors[item.Id] = {};

    if (item.CustodianId == undefined || item.CustodianId == 0) {
      errors[item.Id].CustodianId = "Required field";
    }
  });

  return errors;
}

export default Securities;
